import { render, staticRenderFns } from "./GrafikWeekly.vue?vue&type=template&id=885f09e6"
import script from "./GrafikWeekly.vue?vue&type=script&lang=js"
export * from "./GrafikWeekly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports